module.exports = __webpack_public_path__ + "SP_SPT10-Soccer-d7a26d48f0d3dd67a543d61e4810842a.png";